import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "./index";
import { baseUrl } from "../axios/axios";
import axios from "./../axios/axios";
import { adminCMSActions } from "./admin-cms-slice";

export const fetchAllBranchMarketplaces = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchAllBranchMarketplacesStart());
    axios
      .get(baseUrl + "/branch_marketplace", {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(adminCMSActions.allBranchMarketplaces(response.data));
      })
      .catch((error) => {
        console.log("error fetchAllBranchMarketplaces: ");
        dispatch(adminCMSActions.fetchAllBranchMarketplacesFailed(error));
      });
  };
};

export const fetchAllMarketplacesForBranchMarketplace = (
  branchMarketplaceId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchMarketplacesStart());
    axios
      .get(baseUrl + "/branch_marketplace/marketplace/" + branchMarketplaceId, {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(adminCMSActions.fetchMarketplaces(response.data));
      })
      .catch((error) => {
        console.log("error fetchAllMarketplaces: " + error);
        dispatch(adminCMSActions.fetchMarketplacesFailed(error));
      });
  };
};

export const fetchArticlesFromSingleMarketplace = (
  branchMarketplaceId: number,
  marketplaceId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchArticlesFromSingleMarketplaceStart());
    axios
      .get(
        baseUrl +
          "/item_in_marketplace/items/" +
          branchMarketplaceId +
          "/" +
          marketplaceId +
          "/0?numOfReturns=30000",
        { params: { access_token: localStorage.getItem("token") } }
      )
      .then((response) => {
        dispatch(
          adminCMSActions.fetchArticlesFromSingleMarketplace(response.data.list)
        );
      })
      .catch((error) => {
        console.log("error fetchArticlesFromSingleMarketplace" + error);
        dispatch(
          adminCMSActions.fetchArticlesFromSingleMarketplaceFailed(error)
        );
      });
  };
};

export const changeArticleVisibilityValue = (
  data: [
    {
      branchMarketplaceId: number;
      itemId: number;
      apotekaRs: boolean;
    }
  ]
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.changeArticleVisibilityValueStart());
    const URL = "/item_in_marketplace/branch_marketplace";
    axios
      .put(URL, data, {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(adminCMSActions.changeArticleVisibilityValueSuccess());
        dispatch(adminCMSActions.updateArticleVisibilityValue(data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(adminCMSActions.changeArticleVisibilityValueFailed());
      });
  };
};

export const changeArticleOutletValue = (
  data: [
    {
      branchMarketplaceId: number;
      marketplaceId: number;
      itemId: number;
      outletMarket: boolean;
    }
  ]
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.changeArticleOutletValueStart());
    const URL = "/item_in_marketplace/";
    axios
      .put(URL, data, {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(adminCMSActions.changeArticleOutletValueSuccess());
        dispatch(adminCMSActions.updateArticleOutletValue(data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(adminCMSActions.changeArticleOutletValueFailed());
      });
  };
};

export const fetchAllArticlesForBranchMarketplace = (
  branchMarketplaceId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchAllArticlesForBranchMarketplaceStart());
    axios
      .get(baseUrl + "/branch_marketplace/item/" + branchMarketplaceId, {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(
          adminCMSActions.fetchAllArticlesForBranchMarketplace(response.data)
        );
      })
      .catch((error) => {
        console.log("error fetchArticlesFromSingleMarketplace" + error);
        dispatch(
          adminCMSActions.fetchAllArticlesForBranchMarketplaceFailed(error)
        );
      });
  };
};

export const fetchMobileAdvertisement = (
  appBrandId?: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchMobileAdvertisementsStart());

    const brandId = appBrandId || 1; // Default to Apoteka RS

    axios
      .get(baseUrl + "/advertisement?type=mobile&fileType=all", {
        headers: {
          "ApotekaRS-App-Brand-ID": brandId.toString(),
        },
      })
      .then((response) => {
        dispatch(adminCMSActions.fetchMobileAdvertisements(response.data));
      })
      .catch((error) => {
        console.log("error fetchMobileAdvertisement " + error);
        dispatch(adminCMSActions.fetchMobileAdvertisementsFailed(error));
      });
  };
};

export const fetchWebAdvertisement = (
  appBrandId?: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.fetchWebAdvertisementsStart());

    const brandId = appBrandId || 1; // Default to Apoteka RS

    axios
      .get(baseUrl + "/advertisement?type=web", {
        headers: {
          "ApotekaRS-App-Brand-ID": brandId.toString(),
        },
      })
      .then((response) => {
        dispatch(adminCMSActions.fetchWebAdvertisements(response.data));
      })
      .catch((error) => {
        console.log("error fetchWebAdvertisement " + error);
        dispatch(adminCMSActions.fetchWebAdvertisementsFailed(error));
      });
  };
};

export const deleteAdvertisement = (
  advertisementID: number,
  appBrandId: number,
  advertisementType: "mobile" | "web"
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(adminCMSActions.deleteAdvertisementStart());
    const URL = baseUrl + "/advertisement/" + advertisementID;
    axios
      .delete(URL, { params: { access_token: localStorage.getItem("token") } })
      .then((response) => {
        console.log("deleteAdvertisementSuccess");
        dispatch(adminCMSActions.deleteAdvertisementSuccess());

        // Only fetch the appropriate type with the correct brand ID
        if (advertisementType === "mobile") {
          dispatch(fetchMobileAdvertisement(appBrandId));
        } else {
          dispatch(fetchWebAdvertisement(appBrandId));
        }
      })
      .catch((error) => {
        console.log("delete advertisement error: " + error);
        dispatch(adminCMSActions.deleteAdvertisementFailed());
      });
  };
};

export const createNewAdvertisement = (
  fileObject: FormData,
  appBrandId?: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(adminCMSActions.createNewAdvertisementStart());

    const brandId = appBrandId || 1; // Default to Apoteka RS

    // Add appBrandId to the FormData
    const advertisementData = JSON.parse(
      fileObject.get("advertisement") as string
    );
    advertisementData.appBrandId = brandId;
    fileObject.set("advertisement", JSON.stringify(advertisementData));

    const URL = baseUrl + "/advertisement/";
    axios
      .post(URL, fileObject, {
        headers: {
          "ApotekaRS-App-Brand-ID": brandId.toString(),
        },
      })
      .then((response) => {
        // todo uraditi update niza u reduxu umesto fetcha
        // console.log(response.data)
        dispatch(adminCMSActions.createNewAdvertisementSuccess(response.data));
        // Refetch appropriate advertisements
        if (response.data.type !== "mobile") {
          dispatch(fetchWebAdvertisement(brandId));
        } else {
          dispatch(fetchMobileAdvertisement(brandId));
        }
      })
      .catch((error) => {
        console.log("Error createNewAdvertisement: " + error);
        dispatch(adminCMSActions.createNewAdvertisementFailed());
      });
  };
};

export const updateAdvertisement = (
  fileObject: any,
  appBrandId: number,
  advertisementType: "mobile" | "web"
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(adminCMSActions.updateAdvertisementStart());
    const URL = baseUrl + "/advertisement/";
    axios
      .put(URL, fileObject, {
        params: { access_token: localStorage.getItem("token") },
        headers: {
          "ApotekaRS-App-Brand-ID": appBrandId.toString(),
        },
      })
      .then((response) => {
        dispatch(adminCMSActions.updateAdvertisementSuccess());

        // Only fetch the appropriate type with the correct brand ID
        if (advertisementType === "mobile") {
          dispatch(fetchMobileAdvertisement(appBrandId));
        } else {
          dispatch(fetchWebAdvertisement(appBrandId));
        }
      })
      .catch((error) => {
        console.log("Error updateAdvertisement: " + error);
        dispatch(adminCMSActions.updateAdvertisementFailed());
      });
  };
};

export const sendPushNotification = (
  data: any
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(adminCMSActions.sendPushNotificationStart());
    const URL = baseUrl + "/advertisement/notif";
    axios
      .post(URL, data, {
        params: { access_token: localStorage.getItem("token") },
      })
      .then((response) => {
        dispatch(adminCMSActions.sendPushNotificationSuccess(response.data));
      })
      .catch((error) => {
        console.log("Error createNewAdvertisement: " + error);
        dispatch(adminCMSActions.sendPushNotificationFailed());
      });
  };
};
